import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import DateBanner from './DateBanner.jsx';
import TabLauncher from './TabLauncher.jsx';

const drawerWidth = 260;

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    position: 'absolute',
    top: '65px',
    bottom: '0px',
    left: '0px',
    right: '0px',
    overflowy: 'auto',
  },
  root: {
    flexGrow: 1,
  },
  grow: {
    flexGrow: 1,
  },
  tabBar: {
    boxShadow: 'none',
    position: 'fixed',
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  banner: {
    marginRight: theme.spacing(2),
  },
  badge: {
    backgroundColor: theme.palette.warning.light,
  },
  divider: {
    borderLeft: `1px solid ${theme.palette.neutral.main}`,
    height: '2em',
    marginLeft: '0.3em',
  },
  profile: {
    padding: '5px 10px 5px 10px',
    borderRadius: '5px',
    display: 'flex',
    alignItems: 'center',
    marginLeft: '1.3em',
    flexShrink: 0,
  },
  logo: {
    maxWidth: drawerWidth,
    maxHeight: 64, // TODO: set based on height of app bar
  },
  tabLayout: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  flexSpacer: {
    width: '260px',
  },
}));
const TabRenderer = ({ title, children }) => {
  // TODO: mobile styling if needed
  // const isMobile = useMediaQuery((mqTheme) => mqTheme.breakpoints.down('xs'));

  const classes = useStyles();
  const theme = useTheme();

  const toolbarBackground = theme.palette.type === 'dark' ? '#1f1f1f' : '#ffffff';
  const toolbarForeground = theme.palette.type === 'dark' ? '#ffffff' : '#43425d';

  return (
    // eslint-disable-next-line react/jsx-filename-extension
    <TabLauncher title={title}>
      <div className={classes.root}>
        <AppBar position="fixed" className={classes.tabBar}>
          <Toolbar style={{ backgroundColor: toolbarBackground, color: toolbarForeground }}>
            <div className={classes.tabLayout}>
              {/* <div className={classes.toolbar}> */}
              <img
                className={classes.logo}
                src={`${window.location.origin}/images/${
                  theme.palette.type === 'dark' ? 'premisys_logo_dark.svg' : 'premisys_logo.svg'
                }`}
                alt="PremiSys"
              />
              {/* </div> */}
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                className={classes.menuButton}
              >
                <MenuIcon />
              </IconButton>
              <Hidden smDown implementation="css">
                <DateBanner className={classes.banner} />
              </Hidden>
              <div className={classes.flexSpacer} />
            </div>
          </Toolbar>
        </AppBar>
      </div>
      <main className={classes.content}>{children}</main>
    </TabLauncher>
  );
};

export default TabRenderer;
